\rtr-accordion-template-config
    width: 100%
    min-height: 60px
    height: 60px
    display: flex
    flex-direction: column
    justify-content: flex-start
    flex-shrink: 0
    flex-basis: 60px
    border: 1px solid #D0D0D6
    border-radius: 10px
    color: #46465B
    background-color: #fff
    overflow: hidden
    box-shadow: 0px 3px 8px 0px #0000000D
    .RACollapsibleRow
        position: relative
        width: 100%
        height: 60px
        display: flex
        align-items: center
        cursor: pointer
        opacity: 1
        flex-shrink: 0
        border-radius: 10px
        overflow: hidden
    .RACollapsibleRowHidden
        height: 0
        opacity: 0
    .RAContent
        width: 100%
        height: 0
        min-height: 0
        overflow: hidden
    .RAContentExpanded
        height: unset
        flex-grow: 1
        overflow-x: hidden
        overflow-y: auto
    .RAArrowWrapper
        position: absolute
        right: 20px
        top: 50%
        transform: translateY(-50%)
        stroke: #46465B
        z-index: 5
    .RACollapsibleDisableExpanded
        cursor: default
        opacity: 0.7

.RACollapsibleOpened
    height: unset
    flex-grow: 1
    .RAArrow
        transform: rotateZ(180deg)